export default __webpack_public_path__ + "static/media/Linkedin.6074f5aa.svg";